/**
 * Parse access and refresh tokens from URL hash fragment.
 * Expected format: #token=xxx&refresh=yyy
 */
export function parseHashTokens(): { token: string; refresh: string } | null {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) return null;

  const params = new URLSearchParams(hash.substring(1));
  const token = params.get("token");
  const refresh = params.get("refresh");

  if (!token) return null;
  return { token, refresh: refresh ?? "" };
}

/**
 * Build a redirect URL with tokens embedded in the hash fragment.
 * Tokens are in the hash so they're never sent to the server.
 */
export function buildTokenRedirectUrl(
  appUrl: string,
  accessToken: string,
  refreshToken: string,
): string {
  const base = appUrl.replace(/\/$/, "");
  return `${base}#token=${encodeURIComponent(accessToken)}&refresh=${encodeURIComponent(refreshToken)}`;
}

/**
 * Clear token hash from the URL without triggering navigation.
 */
export function clearHashTokens(): void {
  if (window.location.hash) {
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
  }
}
